import React from "react"
import {Link} from "react-router-dom"
import moment from "moment"
import useMyRescues from "hooks/useMyRescues"
import Rescues from "components/rescue/Rescues"
import {capitalizeFirstLetter} from "utils/text_utils"
import "./HomeRescues.css"


export default function HomeRescues(props) {

    const stored = (() => {
        try {
            const raw = localStorage.getItem('rescue-new')
            if (!raw) return null
            const {rescue} = JSON.parse(raw)
            if (!rescue) return null
            const name = [rescue.subject?.given_name, rescue.subject?.family_name].filter(Boolean).join(' ')
            const time = rescue.events?.[0]?.time ?? rescue.created
            const location = rescue.location?.piste?.name ?? rescue.location?.description
            return {name, time, location}
        } catch { return null }
    })()

    const {data, isLoading} = useMyRescues()

    return <section id="my-rescues" className="container-fluid shadow white">
        <div className="" id="head">
            <h3>Moje povredne liste</h3>
            <div id="new-rescue">
                <Link className="btn btn-danger" to="/rescue">{stored ? <>Nastavi povrednu listu</> : <>Nova povredna lista</>}</Link>
                {stored && <span className="stored-info">
                    {stored.name && <>{stored.name}</>}
                    {stored.location && <>{stored.name ? ', ' : ''}{stored.location}</>}
                    {stored.time && <>{(stored.name || stored.location) ? ', ' : ''}{capitalizeFirstLetter(moment(stored.time).calendar())}</>}
                </span>}
            </div>
        </div>
        
        {isLoading ? <div id="spinner" className="center"/> : <>
            {data?.length > 0 ? <Rescues rescues={data}/> : <div>
                <p>Ovde je spisak tvojih skorašnjih i otvorenih povrednih listi. Trenutno nemaš nijednu.</p>
                <p>Za više saveta, klikni <Link to="/faq">ovde</Link>.</p>                              
            </div>}                   
        </>}
        
    </section>

}